import { AlertCircle, RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * Aviso de error reutilizable para cualquier llamada de datos.
 * Muestra el motivo y, si se pasa onRetry, un botón para repetir la misma
 * consulta sin recargar la página.
 */
export default function ErrorState({
  message,
  retryLabel = 'Reintentar',
  onRetry,
  dark = false,
  compact = false,
  className,
}) {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center text-center rounded-2xl border',
        compact ? 'gap-3 px-5 py-6' : 'gap-4 px-6 py-10',
        dark ? 'bg-white/5 border-white/15' : 'bg-red-50 border-red-200',
        className
      )}
    >
      <AlertCircle className={dark ? 'text-red-400' : 'text-red-500'} size={compact ? 22 : 32} />
      <p className={cn('font-light', dark ? 'text-white/70' : 'text-gray-600', compact ? 'text-sm' : 'text-base')}>
        {message}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className={cn(
            'inline-flex items-center justify-center gap-2 rounded-xl font-bold text-sm transition-all min-h-[44px] px-5 w-full sm:w-auto',
            dark
              ? 'bg-white/10 text-white hover:bg-white/20'
              : 'bg-white text-brand-blue border border-brand-blue/25 hover:bg-blue-50'
          )}
        >
          <RefreshCw size={15} /> {retryLabel}
        </button>
      )}
    </div>
  );
}